import React, { useEffect, useReducer, useState } from "react";
import {
  Badge,
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Empty,
  Form,
  Input,
  Modal,
  Popconfirm,
  Result,
  Row,
  Select,
  Space,
  Table,
  TimePicker,
  Tooltip,
  TreeSelect,
  Typography,
} from "antd";
import moment from "moment";
import {
  errorHandle,
  generateArrWeekAndDays,
  getDaysArray,
  openNotificationWithIcon,
  validateMessages,
  validatePermission,
} from "../../Function";
import {
  DeleteItemLichLamViecApi,
  DelTaoLichTuDongcApi,
  EditItemLichLamViecApi,
  LichLamViecApi,
  TaoLichLamViecApi,
} from "../../../api/getLichlamviec";
import CaLamViecApi from "../../../api/getCaLamViec";
import { ListMemberOfTeamAvailableApi } from "../../../api/getTeamMember";
import { useStepsForm } from "sunflower-antd";
import { useSelector } from "react-redux";
import { ListBoPhanApi } from "../../../api/getListTeam";
import {
  CarryOutOutlined,
  DoubleRightOutlined,
  InfoOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { MdOutlineAutoDelete } from "react-icons/md";

const { Search } = Input;
const { Link } = Typography;

const WeekdayScheduleReducer = (state, action) => {
  const lsWeekday = [
    { id: "T2", name: "Thứ 2" },
    { id: "T3", name: "Thứ 3" },
    { id: "T4", name: "Thứ 4" },
    { id: "T5", name: "Thứ 5" },
    { id: "T6", name: "Thứ 6" },
    { id: "T7", name: "Thứ 7" },
    { id: "CN", name: "Chủ nhật" },
  ];
  for (let item of lsWeekday) {
    if (action.type === "checkbox" + item.id) {
      return {
        ...state,
        ["checkbox" + item.id]: action.boolcheck,
        ["filterOption" + item.id]:
          action.boolcheck === false
            ? state.caLamViec
            : state["filterOption" + item.id],
      };
    }
    if (action.type === "selected" + item.id) {
      const lsTemp = CheckTimeRangeDuplicate(
        state.caLamViec,
        action.selected,
        state.currentDate
      );
      return {
        ...state,
        ["selected" + item.id]: action.selected,
        ["filterOption" + item.id]: lsTemp,
      };
    }
  }
};

const getHeader = (data, date) => {
  return (
    <span>
      {new Date(date[data]).getDay() === 0
        ? "CN"
        : "Thứ " + (new Date(date[data]).getDay() + 1)}
      <br />
      {moment(date[data]).format("DD/MM/YYYY")}
    </span>
  );
};

const fineLsCa = (lsCa, item, currentDate) => {
  let lsTemp = JSON.parse(JSON.stringify(lsCa));
  for (const j in item) {
    for (const i in JSON.parse(JSON.stringify(lsCa))) {
      if (
        lsCa[i].gioVao === item[j].gioVao &&
        JSON.parse(JSON.stringify(lsCa))[i].gioRa === item[j].gioRa
      ) {
        lsTemp = lsTemp.filter(function (e) {
          return e.id !== JSON.parse(JSON.stringify(lsCa))[i].id;
        });
      } else {
        const startTime1 = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate(),
          parseInt(JSON.parse(JSON.stringify(lsCa))[i].gioVao.split(":")[0]),
          parseInt(JSON.parse(JSON.stringify(lsCa))[i].gioVao.split(":")[1]),
          0
        );
        const endTime1 = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate(),
          parseInt(JSON.parse(JSON.stringify(lsCa))[i].gioRa.split(":")[0]),
          parseInt(JSON.parse(JSON.stringify(lsCa))[i].gioRa.split(":")[1]),
          0
        );
        const k = item[j];
        const startTime2 = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate(),
          parseInt(k.gioVao.split(":")[0]),
          parseInt(k.gioVao.split(":")[1]),
          0
        );
        const endTime2 = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate(),
          parseInt(k.gioRa.split(":")[0]),
          parseInt(k.gioRa.split(":")[1]),
          0
        );
        if (startTime1 <= endTime2 && startTime2 < endTime1) {
          lsTemp = lsTemp.filter(function (e) {
            return e.id !== JSON.parse(JSON.stringify(lsCa))[i].id;
          });
        }
      }
    }
  }
  return lsTemp;
};

const ModalAddSingleItemLichLamViec = ({
  item,
  visible,
  onCancel,
  currentDate,
  lsCa,
  userId,
  userName,
  updateData,
  lsDate,
}) => {
  const [itemLsCa, setItemLsCa] = useState(lsCa);
  const [itemLsCaTemp, setItemLsCaTemp] = useState(lsCa);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    setSelected([]);
    if (item.length == 0) {
      let createLsCa = [];
      let lsTemp = [];
      lsCa.forEach((element) => {
        if (lsTemp.length == 0 && createLsCa.length != 0) {
          return;
        }
        createLsCa.push(
          moment(currentDate).format("YYYY-MM-DD") +
          "|" +
          element.gioVao.toString().substr(0, 5) +
          "|" +
          element.gioRa.toString().substr(0, 5) +
          "|" +
          element.id
        );

        // check khung giờ
        const currentSelect = createLsCa.map(
          (itemS) => itemS.split("|")[1] + "-" + itemS.split("|")[2]
        );
        lsTemp = CheckTimeRangeDuplicate(lsCa, currentSelect, currentDate);
      });
      setItemLsCa(lsTemp);
      setSelected(createLsCa);
      // setItemLsCa([]);
    }
  }, [visible]);

  useEffect(() => {
    let lsTemp = fineLsCa(lsCa, item, currentDate);
    setItemLsCa(lsTemp);
    setItemLsCaTemp(lsTemp);
  }, [item]);

  useEffect(() => {
    const currentSelect = selected.map(
      (item) => item.split("|")[1] + "-" + item.split("|")[2]
    );
    const lsTemp = CheckTimeRangeDuplicate(
      itemLsCaTemp,
      currentSelect,
      currentDate
    );
    setItemLsCa(lsTemp);
  }, [selected]);

  const onOk = () => {
    let array = [];
    let arrayDateExist = [];
    for (const i of JSON.parse(JSON.stringify(selected))) {
      let obj = {};
      const lsTemp = i.split("|");
      obj.idUser = userId;
      obj.gioVao = lsTemp[1];
      obj.gioRa = lsTemp[2];
      obj.ngay = lsTemp[0];
      array.push(obj);
      arrayDateExist.push(lsTemp[0]);
    }
    //check
    lsDate = lsDate.filter(
      (item) => moment(currentDate).month() == moment(item).month()
    );
    for (const iDate of lsDate.filter(
      (item) => !arrayDateExist.includes(moment(item).format("YYYY-MM-DD"))
    )) {
      let objTemp = {};
      objTemp.idUser = userId;
      objTemp.gioVao = "null";
      objTemp.gioRa = "null";
      objTemp.ngay = moment(iDate).format("YYYY-MM-DD");
      array.push(objTemp);
    }

    TaoLichLamViecApi({
      listUser: array,
      cbx_auto: false,
      tungay: moment(new Date(lsDate[0])).format("YYYYMMDD"),
      denngay: moment(new Date(lsDate[lsDate.length - 1])).format("YYYYMMDD"),
    })
      .then((res) => {
        updateData();
        onCancel();
      })
      .catch((err) => {
        errorHandle(err);
      });
  };

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      title={
        <>
          Tạo lịch làm việc - {userName && userName.nhanvien} -{" "}
          {moment(currentDate).format("dd, DD/MM/YYYY")}
        </>
      }
      onOk={onOk}
    >
      <div className={"row"}>
        <Select
          mode={"multiple"}
          allowClear
          style={{ width: "100%" }}
          placeholder="Chọn khung giờ"
          onChange={setSelected}
          value={selected}
        >
          {itemLsCa.map((item, index) => (
            <Select.Option
              key={index + item.id}
              value={
                moment(currentDate).format("YYYY-MM-DD") +
                "|" +
                item.gioVao.toString().substr(0, 5) +
                "|" +
                item.gioRa.toString().substr(0, 5) +
                "|" +
                item.id
              }
            >
              <span>
                {item.gioVao.toString().substr(0, 5)}-
                {item.gioRa.toString().substr(0, 5)}
              </span>
            </Select.Option>
          ))}
        </Select>
      </div>
    </Modal>
  );
};

const ModalEditSingleItemLichLamViec = ({
  item,
  visible,
  onCancel,
  currentDate,
  lsCa,
  userId,
  userName,
  updateData,
}) => {
  const [timeStart, setTimeStart] = useState(null);
  const [timeEnd, setTimeEnd] = useState(null);
  useEffect(() => {
    if (item && item.length > 0) {
      setTimeStart(
        moment(
          moment(new Date()).format("YYYYMMDD") + item[0].gioVao,
          "YYYYMMDDHH:mm:ss"
        )
      );
      setTimeEnd(
        moment(
          moment(new Date()).format("YYYYMMDD") + item[0].gioRa,
          "YYYYMMDDHH:mm:ss"
        )
      );
    }
  }, [visible]);

  const onOk = () => {
    let array = [];
    let obj = {};
    if (timeStart >= timeEnd) {
      openNotificationWithIcon("error", "Lỗi", "Giờ ra phải lớn hơn giờ vào");
      return;
    }
    obj.idUser = userId;
    obj.id = item[0].id;
    obj.gioVao = moment(timeStart._d).format("HH:mm");
    obj.gioRa = moment(timeEnd._d).format("HH:mm");
    obj.ngay = moment(currentDate).format("YYYY-MM-DD");
    array.push(obj);
    EditItemLichLamViecApi({ listUser: array })
      .then((res) => {
        updateData();
        onCancel();
      })
      .catch((err) => {
        errorHandle(err);
      });
  };

  const onSelectTimeStart = (value) => {
    setTimeStart(value);
  };

  const onSelectTimeEnd = (value) => {
    setTimeEnd(value);
  };

  const getDisableHour = () => {
    const timeIn = timeStart ? timeStart._d.getHours() : 0;
    let arrCheck = [...Array(24).keys()];
    return arrCheck.filter((item) => item < timeIn);
  };
  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      title={
        <>
          Thay đổi khung giờ - {userName && userName.nhanvien} -{" "}
          {moment(currentDate).format("dd, DD/MM/YYYY")}
        </>
      }
      onOk={onOk}
    >
      <div className={"row"}>
        <div className="col-sm-6">
          <TimePicker
            format="HH:mm"
            placeholder={"Giờ vào"}
            onSelect={(value) => onSelectTimeStart(value)}
            value={timeStart}
            style={{ width: "100%" }}
            minuteStep={15}
            allowClear={false}
          />
        </div>
        <div className="col-sm-6">
          <TimePicker
            format="HH:mm"
            placeholder={"Giờ ra"}
            onSelect={(value) => onSelectTimeEnd(value)}
            value={timeEnd}
            style={{ width: "100%" }}
            minuteStep={15}
            disabledHours={getDisableHour}
            allowClear={false}
          />
        </div>
      </div>
    </Modal>
  );
};

const RenderSingleInnerItem = ({
  text,
  userId,
  setUserId,
  item,
  index,
  updateData,
  setIsShowAddItem,
  setCurrentItem,
  dateSelected,
  setDateSelected,
  setIsShowEditItem,
  checkPermissionTao,
  record,
  setUserName,
}) => {
  const [display, setDisplay] = useState("notdisplayed");
  const showButton = (e) => {
    e.preventDefault();
    if (checkPermissionTao) {
      setDisplay("displayed");
    } else {
      setDisplay("notdisplayed");
    }
  };

  const hideButton = (e) => {
    e.preventDefault();
    setDisplay("notdisplayed");
  };
  const onDeleteItem = () => {
    const lsDateDelete = [moment(dateSelected).format("YYYY-MM-DD")];
    DeleteItemLichLamViecApi({
      id: item.id,
      ngayXoa: lsDateDelete,
      user: userId,
      typeDeleteLHC: "Delete_time", // Delete_time: xóa từng khung giờ | Delete_week: xóa cả tuần | Delete_Team: xóa theo team trong tuần
    })
      .then((res) => {
        updateData();
      })
      .catch((err) => {
        errorHandle(err);
      });
  };

  const onAddItem = () => {
    setCurrentItem(text.ca);
    setDateSelected(dateSelected);
    setUserId(userId);
    setIsShowAddItem(true);
    setUserName(record);
  };

  const onEditItem = () => {
    setCurrentItem([item]);
    setDateSelected(dateSelected);
    setUserId(userId);
    setIsShowEditItem(true);
    setUserName(record);
  };

  if (item.gioVao == null) {
    // console.log(item);
    openNotificationWithIcon(
      "error",
      "Có lỗi dữ liệu, vui lòng liên hệ admin để xử lý."
    );
    return <div></div>;
  }

  return (
    <div
      key={index}
      style={{ background: item.background, color: item.color }}
      className={"mt-1 p-1 productbox"}
      onMouseEnter={(e) => showButton(e)}
      onMouseLeave={(e) => hideButton(e)}
    >
      {item.gioVao.toString().substr(0, 5)} -{" "}
      {item.gioRa.toString().substr(0, 5)}
      <div className={display}>
        <div style={{ textAlign: "center", width: "100%" }}>
          <button
            className={"btn btn-primary btn-rounded"}
            onClick={onAddItem}
            title="Tạo lịch làm việc"
          >
            <i className={"fa fa-plus"}></i>
          </button>
          <button
            className={"btn btn-danger btn-rounded"}
            onClick={onDeleteItem}
            title="Xóa ca hiện tại"
          >
            <i className={"fa fa-trash"}></i>
          </button>
          <button
            className={"btn btn-success btn-rounded"}
            onClick={onEditItem}
            title="Điều chỉnh ca hiện tại"
          >
            <i className={"fa fa-edit"}></i>
          </button>
        </div>
      </div>
    </div>
  );
};

const RenderItemRow = ({
  text,
  updateData,
  setIsShowAddItem,
  setCurrentItem,
  dateSelected,
  setCurrentDateSelected,
  setUserId,
  setUserName,
  setIsShowAddItemNew,
  record,
  setIsShowEditItem,
  teamPermissions,
}) => {
  const [checkPermissionTao, setCheckPermissionTao] = useState(false);

  const RenderItemCell = ({ value, userId, checkPermissionTao }) => {
    return value.map((item, index) => (
      <RenderSingleInnerItem
        key={index}
        userId={userId}
        setUserId={setUserId}
        text={text}
        item={item}
        index={index}
        updateData={updateData}
        setIsShowAddItem={setIsShowAddItem}
        setIsShowEditItem={setIsShowEditItem}
        setCurrentItem={setCurrentItem}
        dateSelected={dateSelected}
        setDateSelected={setCurrentDateSelected}
        checkPermissionTao={checkPermissionTao}
        record={record}
        setUserName={setUserName}
      />
    ));
  };

  useEffect(() => {
    const arrTeam = teamPermissions
      .filter(
        (item) =>
          item.phanquyen__ten_pq === "create_working_schedule_xx" &&
          item.team__tenTeam == record.team__tenTeam
      )
      .map((item, index) => {
        return item.phanquyen__ten_pq;
      });
    setCheckPermissionTao(
      validatePermission(arrTeam, "create_working_schedule_xx")
    );
  }, []);

  const onAddItem = () => {
    setCurrentItem([]);
    setCurrentDateSelected(dateSelected);
    setUserId(record.id);
    setUserName(record);
    setIsShowAddItem(true);
  };

  const RenderItemCellBlank = () => {
    // console.log(record)
    return (
      <Button type={"primary"} size={"small"} onClick={onAddItem}>
        <i className={"fa fa-plus"}></i>
      </Button>
    );
  };

  return (
    <>
      <div style={{ textAlign: "center", width: "100%" }}>
        {text ? (
          <RenderItemCell
            value={text.ca}
            userId={text.userId}
            checkPermissionTao={checkPermissionTao}
          />
        ) : (
          checkPermissionTao && <RenderItemCellBlank />
        )}
      </div>
    </>
  );
};

const CheckTimeRangeDuplicate = (caLamViec, itemSelected, currentDate) => {
  let lsTemp = JSON.parse(JSON.stringify(caLamViec));
  for (const j in itemSelected) {
    for (const i in JSON.parse(JSON.stringify(caLamViec))) {
      if (
        caLamViec[i].gioVao === itemSelected[j].gioVao &&
        JSON.parse(JSON.stringify(caLamViec))[i].gioRa === itemSelected[j].gioRa
      ) {
        lsTemp = lsTemp.filter(function (e) {
          return e.id !== JSON.parse(JSON.stringify(caLamViec))[i].id;
        });
      } else {
        const startTime1 = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate(),
          parseInt(
            JSON.parse(JSON.stringify(caLamViec))[i].gioVao.split(":")[0]
          ),
          parseInt(
            JSON.parse(JSON.stringify(caLamViec))[i].gioVao.split(":")[1]
          ),
          0
        );
        const endTime1 = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate(),
          parseInt(
            JSON.parse(JSON.stringify(caLamViec))[i].gioRa.split(":")[0]
          ),
          parseInt(
            JSON.parse(JSON.stringify(caLamViec))[i].gioRa.split(":")[1]
          ),
          0
        );
        const k = itemSelected[j];
        // console.log(k)
        const startTime2 = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate(),
          parseInt(k.split("-")[0].split(":")[0]),
          parseInt(k.split("-")[0].split(":")[1]),
          0
        );
        const endTime2 = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate(),
          parseInt(k.split("-")[1].split(":")[0]),
          parseInt(k.split("-")[1].split(":")[1]),
          0
        );
        if (startTime1 <= endTime2 && startTime2 < endTime1) {
          lsTemp = lsTemp.filter(function (e) {
            return e.id !== JSON.parse(JSON.stringify(caLamViec))[i].id;
          });
        }
      }
    }
  }
  return lsTemp;
};

const ModalTaoLichLamViec = ({
  visible,
  onCancel,
  caLamViec,
  lsDate,
  data,
  lsMemberId,
  currentTeam,
  lsTeam,
  currentSelectedDate,
  userInfo,
}) => {
  lsDate = lsDate.filter(
    (item) => moment(currentSelectedDate).month() == moment(item).month()
  );
  const arrTeam = userInfo.team_permissions
    .filter((item) => item.phanquyen__ten_pq === "create_working_schedule_xx")
    .map((item, index) => {
      return { idTeam: item.team, team: item.team__tenTeam };
    });
  lsTeam = [...new Set(arrTeam)];
  const firstDay = moment(new Date(lsDate[0])).format("YYYYMMDD");
  const endDay = moment(new Date(lsDate[lsDate.length - 1])).format("YYYYMMDD");

  const onOK = () => { };

  const generatePreData = (lsDate, values) => {
    let obj = {};
    for (const iDate of lsDate) {
      if (
        !values["ca-" + moment(iDate).format("YYYY-MM-DD")] ||
        values["ca-" + moment(iDate).format("YYYY-MM-DD")].length === 0
      ) {
        obj["ca-" + moment(iDate).format("YYYY-MM-DD")] = [
          moment(iDate).format("YYYY-MM-DD") + "|null|null|null",
        ];
      } else {
        obj["ca-" + moment(iDate).format("YYYY-MM-DD")] =
          values["ca-" + moment(iDate).format("YYYY-MM-DD")];
      }
    }
    return obj;
  };

  const BoxNewSchedule = () => {
    const {
      form,
      current,
      gotoStep,
      stepsProps,
      formProps,
      submit,
      formLoading,
    } = useStepsForm({
      async submit(values) {
        let result = await onFinish(values);

        // if (result.status === 200) {
        //   return "ok";
        // }
        // if (result.status === 400) {
        // }
      },
      total: 3,
    });

    const currentDate = new Date();
    const [loadingBtn, setLoadingBtn] = useState(false)
    // const onFinish = async (values) => {
    const onFinish = async () => {
      // console.log(form.getFieldsValue())
      const values = form.getFieldsValue()
      if (values.member == undefined || values.member.length == 0) {
        openNotificationWithIcon("error", "Lỗi", "Vui lòng chọn nhân viên");
        return false;
      }

      const finalData = generatePreData(lsDate, values);
      let lsCaLamViec = [];
      let boolCheckValid = false;

      for (const [key, value] of Object.entries(finalData)) {
        if (key.startsWith("ca-")) {
          for (const i of JSON.parse(JSON.stringify(value))) {
            if (i.toString().split("|")[1] !== "null") {
              boolCheckValid = true;
              lsCaLamViec.push(
                key.replace("ca-", "") +
                "|" +
                i.split("-")[0] +
                "|" +
                i.split("-")[1]
              );
            } else {
              lsCaLamViec.push(i);
            }
          }
        }
      }
      if (!boolCheckValid) {
        openNotificationWithIcon(
          "error",
          "Lỗi",
          "Vui lòng chọn thời gian làm việc"
        );
        return false;
        // return Promise.reject("Vui lòng chọn thời gian làm việc");
      }
      let objTaoLich = [];
      for (let member of values.member) {
        for (let itemCa of lsCaLamViec) {
          let objTemp = {};
          objTemp.idUser = member;
          objTemp.ngay = itemCa.toString().split("|")[0];
          objTemp.gioVao = itemCa.toString().split("|")[1];
          objTemp.gioRa = itemCa.toString().split("|")[2];
          objTaoLich.push(objTemp);
        }
      }

      setLoadingBtn(true)
      await TaoLichLamViecApi({
        listUser: objTaoLich,
        cbx_auto: values.cbx_auto ? values.cbx_auto : false,
        tungay: firstDay,
        denngay: endDay,
      })
        .then((res) => {
          openNotificationWithIcon(
            "success",
            "Tạo lịch thành công"
          );
          form.setFieldValue("member", undefined)
          setLoadingBtn(false)
        })
        .catch((err) => {
          setLoadingBtn(false)
          errorHandle(err);
        });
    };

    const FirstStep = () => {
      const [loading, setLoading] = useState(false);
      const [lsMember, setLsMember] = useState([]);
      const [lsMemberSelected, setLsMemberSelected] = useState(null);
      const [lsTeamSelected, setLsTeamSelected] = useState([]);

      const fetchListTeamMember = (params = {}) => {
        setLoading(true);
        ListMemberOfTeamAvailableApi({ ...params }).then((res) => {
          setLsMember(res.data.filter((item) => !lsMemberId.includes(item.id)));
          setLoading(false);
        });
      };

      useEffect(() => {
        setLsMemberSelected(form.getFieldValue("member") || []);
        const getLsIdTeamNew = lsTeam
          .filter((item) => currentTeam.includes(item.idTeam))
          .map((item) => item.idTeam);
        // setLsTeamSelected(getLsIdTeamNew || []);
        if (getLsIdTeamNew.length > 0) {
          form.setFieldsValue({ team: getLsIdTeamNew });
          setLsTeamSelected(getLsIdTeamNew);
        } else {
          setLsTeamSelected([]);
        }
      }, []);

      useEffect(() => {
        if (lsMemberSelected !== null) {
          fetchListTeamMember({
            listIdTeam: JSON.stringify(lsTeamSelected),
            tuNgay: firstDay,
            denNgay: endDay,
          });
        }
      }, [lsTeamSelected]);

      const onChangeTeam = (value) => {
        fetchListTeamMember({
          listIdTeam: JSON.stringify(value),
          tuNgay: firstDay,
          denNgay: endDay,
        });
        let selected = form.getFieldValue("member") || [];
        let teamSelected = form.getFieldValue("team") || [];
        let MemberSelected = lsMember
          .filter((item) => selected.includes(item.id))
          .filter((item) => teamSelected.includes(item.idTeam))
          .map((item) => item.id);
        setLsTeamSelected(value);
        if (lsMember.length > 0) {
          form.setFieldsValue({ member: MemberSelected });
          setLsMemberSelected(MemberSelected);
        }
      };

      let lsDDD = lsDate.map((element) => moment(element).format("ddd"));
      let lsWeekday = [
        { id: "T2", name: "Thứ 2" },
        { id: "T3", name: "Thứ 3" },
        { id: "T4", name: "Thứ 4" },
        { id: "T5", name: "Thứ 5" },
        { id: "T6", name: "Thứ 6" },
        { id: "T7", name: "Thứ 7" },
        { id: "CN", name: "CN" },
      ];
      lsWeekday = lsWeekday.filter((iday) => lsDDD.includes(iday.id));
      // const [arrSelected, setArrSelected] = useState({'selectedT2':[],'selectedT3':[],'selectedT4':[],'selectedT5':[],'selectedT6':[],'selectedT7':[],'selectedCN':[]})
      const [filterOption, setFilterOption] = useState({
        filterOptionT2: caLamViec,
        filterOptionT3: caLamViec,
        filterOptionT4: caLamViec,
        filterOptionT5: caLamViec,
        filterOptionT6: caLamViec,
        filterOptionT7: caLamViec,
        filterOptionCN: caLamViec,
      });
      const [arrCheckbox, setArrCheckbox] = useState({
        checkboxT2: false,
        checkboxT3: false,
        checkboxT4: false,
        checkboxT5: false,
        checkboxT6: false,
        checkboxT7: false,
        checkboxCN: false,
      });
      const [state, dispatch] = useReducer(WeekdayScheduleReducer, {
        ...filterOption,
        ...arrCheckbox,
        caLamViec,
        currentDate,
      });
      const [caLamAll, setCaLamAll] = useState(caLamViec);

      const validateFormSelectDay = () => {
        let values = form.getFieldsValue();
        for (let i in lsWeekday) {
          const currentSelected =
            values["ca-" + moment(lsDate[i]).format("YYYY-MM-DD")] || [];
          if (
            values["checkbox" + lsWeekday[i].id] &&
            currentSelected.length === 0
          ) {
            openNotificationWithIcon(
              "error",
              "Lỗi",
              `Vui lòng chọn khung giờ làm việc ${lsWeekday[i].name}`
            );
            return false;
          }
        }
        return true;
      };

      // const onChangeCaAll = (value) => {
      //   {
      //     lsWeekday.map((itemWeek, indexWeek) => {
      //       if (form.getFieldValue("checkbox" + itemWeek.id)) {
      //         form.setFieldsValue({
      //           [`ca-${moment(lsDate[indexWeek]).format("YYYY-MM-DD")}`]: value,
      //         });
      //         dispatch({
      //           type: "selected" + itemWeek.id,
      //           selected: value,
      //           date: moment(lsDate[indexWeek]).format("YYYY-MM-DD"),
      //         });
      //       }
      //     });
      //   }
      //   const lsTemp = CheckTimeRangeDuplicate(
      //     state.caLamViec,
      //     value,
      //     state.currentDate
      //   );
      //   setCaLamAll(lsTemp);
      // };

      const onChangeThuAll = (e) => {
        if (e.target.checked === false) {
          form.setFieldsValue({
            slCaAll: [],
          });
          setCaLamAll(caLamViec);

          lsWeekday.map((itemWeek, indexWeek) => {
            form.setFieldsValue({
              ["checkbox" + itemWeek.id]: e.target.checked,
            });
            form.setFieldsValue({
              ["ca-" + moment(lsDate[indexWeek]).format("YYYY-MM-DD")]: [],
              slCaAll: [],
            });
            dispatch({
              type: "checkbox" + itemWeek.id,
              boolcheck: e.target.checked,
            });
          });
        } else {
          let time_value = [];
          let lsTemp = [];
          caLamViec.forEach((element) => {
            // console.log(lsTemp);
            // console.log(time_value);
            if (lsTemp.length == 0 && time_value.length != 0) {
              return;
            }
            time_value.push(
              element.gioVao.toString().substr(0, 5) +
              "-" +
              element.gioRa.toString().substr(0, 5)
            );

            // check khung giờ
            lsTemp = CheckTimeRangeDuplicate(
              state.caLamViec,
              time_value,
              state.currentDate
            );
          });

          setCaLamAll(lsTemp);

          lsWeekday.map((itemWeek, indexWeek) => {
            form.setFieldsValue({
              [`ca-${moment(lsDate[indexWeek]).format("YYYY-MM-DD")}`]:
                time_value,
              ["checkbox" + itemWeek.id]: e.target.checked,
            });
            dispatch({
              type: "selected" + itemWeek.id,
              selected: time_value,
              date: moment(lsDate[indexWeek]).format("YYYY-MM-DD"),
            });

            dispatch({
              type: "checkbox" + itemWeek.id,
              boolcheck: e.target.checked,
            });
          });
        }
      };

      const onChangeNV = (value) => {
        setLsMemberSelected(value);
        form.setFieldsValue({ member: value });
        if (
          lsTeamSelected &&
          lsTeamSelected.length > 0 &&
          lsMember.length === 0
        ) {
          openNotificationWithIcon(
            "error",
            "Team đang chọn không có nhân viên chưa xếp lịch làm việc"
          );
        }
      };

      return (
        <>
          {/* <Spin spinning={loading}> */}
          <div className={"row text-center box-select-day-checkbox"}>
            <Row gutter={16}>
              <Col span={10}>
                <Card
                  title="Chọn nhân viên"
                  bordered={false}
                  extra={<DoubleRightOutlined style={{ fontSize: "16px" }} />}
                  headStyle={{ padding: "0px 6px" }}
                  bodyStyle={{ padding: "6px" }}
                >
                  <Form.Item
                    name="team"
                    label="Team"
                    rules={[{ required: true }]}
                  >
                    <TreeSelect
                      style={{ width: "100%" }}
                      dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                      treeData={[
                        {
                          title:
                            lsTeamSelected && lsTeamSelected.length > 0 ? (
                              <span
                                onClick={() => {
                                  setLsTeamSelected([]);
                                  form.setFieldsValue({ team: [] });
                                  onChangeTeam([]);
                                }}
                                style={{
                                  display: "inline-block",
                                  color: "#286FBE",
                                  cursor: "pointer",
                                }}
                              >
                                Bỏ chọn tất cả
                              </span>
                            ) : (
                              <span
                                onClick={() => {
                                  setLsTeamSelected(
                                    lsTeam.map((item) => item.idTeam)
                                  );
                                  form.setFieldsValue({
                                    team: lsTeam.map((item) => item.idTeam),
                                  });
                                  onChangeTeam(
                                    lsTeam.map((item) => item.idTeam)
                                  );
                                }}
                                style={{
                                  display: "inline-block",
                                  color: "#286FBE",
                                  cursor: "pointer",
                                }}
                              >
                                Chọn tất cả
                              </span>
                            ),
                          value: "xxx",
                          disableCheckbox: true,
                          disabled: true,
                        },
                        ...lsTeam.map((item) => {
                          return { title: item.team, value: item.idTeam };
                        }),
                      ]}
                      value={lsTeamSelected} //lsTeamSelected
                      treeDefaultExpandAll
                      treeCheckable={true}
                      maxTagCount={4}
                      allowClear={false}
                      placeholder={"Chọn team"}
                      onChange={onChangeTeam}
                    />
                  </Form.Item>
                  {/* {lsTeamSelected.length > 0 && lsMember.length > 0 && ( */}
                  <Form.Item
                    name="member"
                    label="Nhân viên"
                    rules={[{ required: true, type: "array" }]}
                  >
                    <TreeSelect
                      style={{ width: "100%" }}
                      value={lsMemberSelected}
                      dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                      treeData={[
                        {
                          title:
                            lsMemberSelected && lsMemberSelected.length > 0 ? (
                              <span
                                onClick={() => {
                                  setLsMemberSelected([]);
                                  form.setFieldsValue({ member: [] });
                                }}
                                style={{
                                  display: "inline-block",
                                  color: "#286FBE",
                                  cursor: "pointer",
                                }}
                              >
                                Bỏ chọn tất cả
                              </span>
                            ) : (
                              <span
                                onClick={() => {
                                  setLsMemberSelected(
                                    lsMember.map((item) => item.id)
                                  );
                                  form.setFieldsValue({
                                    member: lsMember.map((item) => item.id),
                                  });
                                }}
                                style={{
                                  display: "inline-block",
                                  color: "#286FBE",
                                  cursor: "pointer",
                                }}
                              >
                                Chọn tất cả
                              </span>
                            ),
                          value: "xxx",
                          disableCheckbox: true,
                          disabled: true,
                        },
                        ...lsMember.map((item) => {
                          return { title: item.username, value: item.id };
                        }),
                      ]}
                      treeDefaultExpandAll
                      treeCheckable={true}
                      maxTagCount={5}
                      allowClear={false}
                      placeholder={"Chọn nhân viên"}
                      onChange={(value) => onChangeNV(value)}
                      disabled={
                        !(lsTeamSelected.length > 0 && lsMember.length > 0)
                      }
                    />
                  </Form.Item>
                  {/* )} */}
                  {/* {loading === false &&
                      lsTeamSelected &&
                      lsTeamSelected.length > 0 &&
                      lsMember.length === 0 && (
                        <h3 className={"text text-danger"}>
                          Team đang chọn không có nhân viên chưa xếp lịch làm việc
                        </h3>
                      )} */}
                </Card>
              </Col>
              <Col span={14}>
                <Card
                  title="Chọn khung giờ"
                  bordered={false}
                  bodyStyle={{ padding: "6px" }} // loading={loading}
                >
                  <Row justify="center">
                    <Col span={24}>
                      <Row>
                        <Col span={11}>
                          <Form.Item
                            name={"ckbThuALL"}
                            label=""
                            valuePropName={"checked"}
                            style={{ marginBottom: "0px", float: "left" }}
                          >
                            <Checkbox
                              onChange={(e) => {
                                form.setFieldsValue({
                                  ["ckbThuALL"]: e.target.checked,
                                });
                                onChangeThuAll(e);
                              }}
                            >
                              Tất cả khung giờ
                            </Checkbox>
                          </Form.Item>
                        </Col>
                        <Col span={11} offset={1} className="styleBadge">
                          <Badge.Ribbon
                            color="gray"
                            text={
                              <Tooltip title="Tích chọn ô [Tạo lịch hàng tuần] để hệ thống tự động tạo theo khung giờ đã chọn (Lưu ý: Hệ thống bắt đầu tạo từ sáng thứ hai hàng tuần hoặc ngày đầu tiên của tháng).">
                                <InfoOutlined />
                              </Tooltip>
                            }
                          >
                            <Form.Item
                              name={"cbx_auto"}
                              label=""
                              valuePropName={"checked"}
                              style={{
                                marginBottom: "0px",
                                float: "left",
                                color: "Background",
                              }}
                            >
                              <Checkbox>Tạo lịch hàng tuần</Checkbox>
                            </Form.Item>
                          </Badge.Ribbon>
                        </Col>

                        {/* <Col span={16}>
                              <Form.Item
                                noStyle
                                shouldUpdate={(prevValues, currentValues) =>
                                  prevValues["ckbThuALL"] !== currentValues["ckbThuALL"]
                                }
                              >
                                {({ getFieldValue }) => {
                                  return (
                                    getFieldValue("ckbThuALL") === true && (
                                      <Form.Item
                                        name={`slCaAll`}
                                        label=""
                                        rules={[{ required: true }]}
                                        style={{
                                          display: "block",
                                          marginBottom: "0px",
                                        }}
                                      >
                                        <Select
                                          mode={"multiple"}
                                          allowClear={false}
                                          style={{ width: "100%" }}
                                          placeholder="Chọn khung giờ"
                                          // maxTagCount={1}
                                          onChange={(value) => {
                                            onChangeCaAll(value);
                                          }}
                                        >
                                          {caLamAll.map((item, index) => (
                                            <Select.Option
                                              key={index + item.gioVao.toString()}
                                              value={
                                                item.gioVao.toString().substr(0, 5) +
                                                "-" +
                                                item.gioRa.toString().substr(0, 5)
                                              }
                                            >
                                              {item.gioVao.toString().substr(0, 5)}-
                                              {item.gioRa.toString().substr(0, 5)}
                                            </Select.Option>
                                          ))}
                                        </Select>
                                      </Form.Item>
                                    )
                                  );
                                }}
                              </Form.Item>
                            </Col> */}
                        <Divider
                          style={{
                            borderTop: "1px solid rgb(190 190 190)",
                            margin: "9px 0px",
                          }}
                        ></Divider>
                      </Row>

                      {lsWeekday.map((itemWeek, indexWeek) => (
                        <Row key={itemWeek.id}>
                          <Col span={6}>
                            <Form.Item
                              name={"checkbox" + itemWeek.id}
                              label=""
                              valuePropName={"checked"}
                              initialValue={state["checkbox" + itemWeek.id]}
                              style={{ marginBottom: "0px", float: "left" }}
                            >
                              <Checkbox
                                onChange={(e) => {
                                  if (e.target.checked === false) {
                                    form.setFieldsValue({
                                      ["ca-" +
                                        moment(lsDate[indexWeek]).format(
                                          "YYYY-MM-DD"
                                        )]: [],
                                    });
                                  }
                                  dispatch({
                                    type: "checkbox" + itemWeek.id,
                                    boolcheck: e.target.checked,
                                  });
                                }}
                              >
                                {itemWeek.name}
                              </Checkbox>
                            </Form.Item>
                          </Col>

                          <Col span={16}>
                            <Form.Item
                              noStyle
                              shouldUpdate={(prevValues, currentValues) =>
                                prevValues["checkbox" + itemWeek.id] !==
                                currentValues["checkbox" + itemWeek.id]
                              }
                            >
                              {({ getFieldValue }) => {
                                return (
                                  getFieldValue("checkbox" + itemWeek.id) ===
                                  true && (
                                    <Form.Item
                                      name={`ca-${moment(
                                        lsDate[indexWeek]
                                      ).format("YYYY-MM-DD")}`}
                                      label=""
                                      rules={[{ required: true }]}
                                      style={{
                                        display: "block",
                                        marginBottom: "0px",
                                      }}
                                    >
                                      <Select
                                        mode={"multiple"}
                                        allowClear={false}
                                        style={{ width: "100%" }}
                                        placeholder="Chọn khung giờ"
                                        // maxTagCount={1}
                                        onChange={(value) => {
                                          // console.log(value);
                                          dispatch({
                                            type: "selected" + itemWeek.id,
                                            selected: value,
                                            date: moment(
                                              lsDate[indexWeek]
                                            ).format("YYYY-MM-DD"),
                                          });
                                        }}
                                      >
                                        {state[
                                          "filterOption" + itemWeek.id
                                        ].map((item, index) => (
                                          <Select.Option
                                            key={index + item.gioVao.toString()}
                                            value={
                                              item.gioVao
                                                .toString()
                                                .substr(0, 5) +
                                              "-" +
                                              item.gioRa.toString().substr(0, 5)
                                            }
                                          >
                                            {item.gioVao
                                              .toString()
                                              .substr(0, 5)}
                                            -
                                            {item.gioRa.toString().substr(0, 5)}
                                          </Select.Option>
                                        ))}
                                      </Select>
                                    </Form.Item>
                                  )
                                );
                              }}
                            </Form.Item>
                          </Col>
                          {indexWeek < lsWeekday.length - 1 && (
                            <Divider
                              style={{
                                borderTop: "0.1px solid rgb(230 230 230)",
                                margin: "9px 0px",
                              }}
                            ></Divider>
                          )}
                        </Row>
                      ))}
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>

            <Divider
              style={{
                borderTop: "0.1px solid rgb(230 230 230)",
                margin: "9px 0px",
              }}
            ></Divider>

            <Form.Item>
              <Button
                style={{ marginRight: 10 }}
                type="primary"
                loading={loadingBtn}
                // htmlType="submit"
                onClick={onFinish}
              >
                Tạo lịch
              </Button>
            </Form.Item>
          </div>
          {/* </Spin> */}
        </>
      );
    };

    return (
      <div>
        <Form
          {...formProps}
          validateMessages={validateMessages}
          layout="vertical"
        >
          <FirstStep />
        </Form>
      </div>
    );
  };

  return (
    <Modal
      title={
        "Tạo lịch làm việc (" +
        moment(lsDate[0]).format("DD/MM/YYYY") +
        "-" +
        moment(lsDate.at(-1)).format("DD/MM/YYYY") +
        ")"
      }
      width={700}
      open={visible}
      onCancel={onCancel}
      onOk={onOK}
      footer={false}
    >
      <div className="row">
        <BoxNewSchedule />
      </div>
    </Modal>
  );
};

const mapDataLichLamViec = (data, lsDate) => {
  let results = [];
  let lsMemberId = [];
  const lsDay = ["CN", "T2", "T3", "T4", "T5", "T6", "T7"];
  for (let i of data) {
    let obj = {};
    obj.nhanvien = i.msnv + "-" + i.username;
    obj.id = i.id;
    obj.team__tenTeam = i.team__tenTeam;
    if (i.dataLichTuDong.length > 0) {
      obj.id_lichtudong = i.dataLichTuDong[0]["id"];
    } else {
      obj.id_lichtudong = null;
    }
    if (i.data.length > 0) {
      lsMemberId.push(i.id);
    }
    for (let k of i.data) {
      let objTemp = {};
      objTemp.ca = k.ca;
      objTemp.userId = i.id;
      obj["col" + lsDay[new Date(k.ngay).getDay()]] = objTemp;
      objTemp.dateHC = k.ngay; // 070823
    }
    results.push(obj);
  }
  return [results, lsMemberId];
};

const ModalDeleteLichHC = ({
  visible,
  onCancel,
  updateData,
  lsDate,
  data,
  currentTeam,
  lsTeam,
  currentSelectedDate,
}) => {
  const [lsCurrentTeam, setlsCurrentTeam] = useState([]);

  useEffect(() => {
    lsDate = lsDate.filter(
      (item) => moment(currentSelectedDate).month() == moment(item).month()
    );
    setlsCurrentTeam(
      lsTeam.filter((item) => currentTeam.includes(item.idTeam))
    );
  }, [visible]);

  const onFinishLHC = (values) => {
    const ls_dateDelete = lsDate.map((item) =>
      moment(item).format("YYYY-MM-DD")
    );

    let countIdHC = 0; //tổng số lượng id trong tất cả các ca làm việc
    for (let iDict in data) {
      for (let iValue in data[iDict]) {
        if (iValue.startsWith("col")) {
          const colT = data[iDict][iValue];
          countIdHC += colT.ca.length;
        }
      }
    }
    if (countIdHC == 0) {
      openNotificationWithIcon(
        "warning",
        "Cảnh báo",
        "Không có lịch làm việc để xóa."
      );
      return false;
    }

    DeleteItemLichLamViecApi({
      ls_dateDelete: ls_dateDelete,
      lsCurrentTeam: lsCurrentTeam,
      typeDeleteLHC: "Delete_Team",
    })
      .then((res) => {
        if (res.data.errorCode == "2") {
          openNotificationWithIcon("warning", "Cảnh báo", res.data.result);
          return false;
        }
        updateData();
        onCancel();
      })
      .catch((err) => {
        errorHandle(err);
      });
  };

  return (
    <Modal
      open={visible}
      onCancel={() => onCancel()}
      footer={false}
      // onOk={onFinish}
      // title={"Xác nhận xóa lịch làm việc của team"}
      className={"timekeeper-error-modal"}
    >
      <Result
        status="error"
        title={
          "Xác nhận xóa lịch làm việc của team " +
          lsCurrentTeam.map((item) => item.team).join(",") +
          " (" +
          moment(lsDate[0]).format("DD/MM/YYYY") +
          "-" +
          moment(lsDate.at(-1)).format("DD/MM/YYYY") +
          ")"
        }
        icon={
          <MdOutlineAutoDelete style={{ color: "#ff4d4f", fontSize: "60px" }} />
        }
        extra={
          <Button type="primary" danger key="Xóa" onClick={onFinishLHC}>
            XÓA LỊCH
          </Button>
        }
      />
    </Modal>
  );
};

export const LichLamViec = () => {
  const defaultPageSize = 50;
  const [pager, setPager] = useState({
    pageSize: defaultPageSize,
    count: 0,
    current: 1,
  });
  //   const [data, setData] = useState( [{
  //     key: '1',
  //     id: 1,
  //     nhanvien: 'John Brown',
  //     age: 32,
  //     address: 'New York Park',
  //   },
  //  ]);
  const [data, setData] = useState([]);
  const [totalPage, setTotalPage] = useState(1);
  const [lsDate, setLsDate] = useState([]);
  const [currentDateSelected, setCurrentDateSelected] = useState(null);
  const [currentItem, setCurrentItem] = useState({});
  const [lsTeam, setLsTeam] = useState([]);
  const [isShowAddItem, setIsShowAddItem] = useState(false);
  const [isShowAddItemNew, setIsShowAddItemNew] = useState(false);
  const [isShowEditItem, setIsShowEditItem] = useState(false);
  const [currentTeam, setCurrentTeam] = useState([]);
  const [lsMemberId, setLsMemberId] = useState([]);
  const [userId, setUserId] = useState(null);
  const [userName, setUserName] = useState(null);
  const [currentSelectedDate, setCurrentSelectedDate] = useState(
    moment(new Date())
  );
  const [loading, setLoading] = useState(false);
  const [lsCaLamViec, setLsCaLamViec] = useState([]);
  const [isCreate, setIsCreate] = useState(false);
  const [isShowTaoLichLamViec, setIsShowTaoLichLamViec] = useState(false);
  const [isShowDeleteLichHC, setIsDeleteLichHC] = useState(false);
  const [search, setSearch] = useState(undefined);
  const [treeData, setTreeData] = useState([]);
  const userInfo = useSelector((state) => state.getUserInfo.userInfo);

  const [lsBoPhan, setLsBoPhan] = useState([]);
  const [currentBoPhan, setCurrentBoPhan] = useState([]);
  const [treeDataBoPhan, setTreeDataBoPhan] = useState([]);
  const [lsAllTeam, setLsAllTeam] = useState([]);
  const [lsAllWeek, setLsAllWeek] = useState([]);
  const [currentWeek, setCurrentWeek] = useState("");

  const fetchCaLamViec = () => {
    CaLamViecApi({ idTeam: JSON.stringify(currentTeam) }).then((res) => {
      setLsCaLamViec(res.data.filter((i) => i.isActive === true));
    });
  };
  const fetchData = (params = {}) => {
    setLoading(true);
    const lsDateInMonth = params.lsDate.filter(
      (item) => moment(currentSelectedDate).month() == moment(item).month()
    );
    LichLamViecApi({
      page: params.page,
      page_size: params.page_size,
      idTeam: JSON.stringify(params.idTeam),
      tungay: moment(new Date(lsDateInMonth[0])).format("YYYYMMDD"),
      denngay: moment(new Date(lsDateInMonth[lsDateInMonth.length - 1])).format(
        "YYYYMMDD"
      ),
      search: params.search,
    })
      .then((res) => {
        const newData = mapDataLichLamViec(res.data.results, lsDateInMonth);
        // setData([]);
        setData(newData[0]);
        setTotalPage(res.data.count);
        setLsMemberId(newData[1]);
        setPager({
          current: params.page,
          pageSize: params.page_size,
          count: res.data.count,
        });
        setLoading(false);
      })
      .catch((err) => {
        errorHandle(err);
        setLoading(false);
      });
  };

  const fetchListTeam = () => {
    ListBoPhanApi().then((res) => {
      const arrTeam = userInfo.team_permissions
        .filter((item) => item.phanquyen__ten_pq === "set_working_schedule_xx")
        .map((item, index) => {
          const idBoPhanForTeam = res.data.filter((itemBP) =>
            itemBP.team.some((itemT) => itemT.id == item.team)
          );
          if (idBoPhanForTeam.length != 0) {
            return {
              idTeam: item.team,
              team: item.team__tenTeam,
              idBoPhan: idBoPhanForTeam[0].id,
            };
          }
          return false;
        })
        .filter((item) => item != false);
      const uniqueArrTeam = [
        ...new Map(arrTeam.map((item) => [item["idTeam"], item])).values(),
      ];
      if (uniqueArrTeam.length === 0) {
        openNotificationWithIcon("error", "Bạn chưa có quyền cho team.");
      }

      const arrIdTeam = uniqueArrTeam.map((item) => item.idTeam);
      const arrBoPhan = res.data.filter(({ team }) =>
        team.some((item) => arrIdTeam.includes(item.id))
      );
      // const arrBoPhan = res.data.filter(itemBP => itemBP.team.map(item=>item.id).filter(x => arrIdTeam.includes(x)))
      if (arrBoPhan.length > 0) {
        setCurrentBoPhan([arrBoPhan[0].id]);
      }
      setLsBoPhan(arrBoPhan);

      setLsAllTeam(uniqueArrTeam);
      if (currentTeam.length === 0) {
        setCurrentTeam([
          arrIdTeam.filter((x) =>
            arrBoPhan[0].team.map((item) => item.id).includes(x)
          )[0],
        ]); // 200423 lấy element đầu tiên đặt trong list
        // setCurrentTeam(uniqueArrTeam.map(item=>item.idTeam));
      }
      setLsTeam(
        uniqueArrTeam.filter((x) =>
          arrBoPhan[0].team.map((item) => item.id).includes(x.idTeam)
        )
      );
      // ListTeamOfMemberManagerApi().then(res => {
      //     setLsTeam(res.data)
      //     if (currentTeam.length === 0) {
      //         setCurrentTeam(res.data.map(item => item.idTeam))
      //     }
      // })
    });
  };

  useEffect(() => {
    if (userInfo.team_permissions.length === 0) {
      openNotificationWithIcon("error", "Bạn chưa có quyền cho team.");
    }
    if (
      userInfo &&
      userInfo.team_permissions &&
      userInfo.team_permissions.length > 0
    ) {
      fetchListTeam();
    }
  }, [userInfo]);

  useEffect(() => {
    if (lsDate.length === 0) {
      const lsDatePre = getDateRange(moment(new Date()));
      setLsDate(lsDatePre);
    }
    // if (currentTeam.length > 0) {
    //     fetchCaLamViec();
    // }
  }, [currentSelectedDate]);

  useEffect(() => {
    if (lsDate.length > 0 && currentTeam.length > 0) {
      fetchData({
        idTeam: currentTeam,
        lsDate: lsDate,
        page: pager.current,
        page_size: pager.pageSize,
        search,
      });
      fetchCaLamViec();
    }
    if (currentTeam.length === 0) {
      setData([]);
    }
  }, [lsDate, currentTeam]);

  useEffect(() => {
    if (lsDate.length > 0 && currentTeam.length > 0) {
      const id = setInterval(() => {
        fetchData({
          idTeam: currentTeam,
          lsDate: lsDate,
          page: pager.current,
          page_size: pager.pageSize,
          search: search,
        });
        clearInterval(id);
      }, 500);
      return () => clearInterval(id);
    }
  }, [search]);
  // useEffect(()=>{
  //     systemInfoApi().then(res=>{
  //         console.log(res)
  //     })
  // },[])

  const updateData = () => {
    fetchData({
      idTeam: currentTeam,
      lsDate: lsDate,
      page: pager.current,
      page_size: pager.pageSize,
      search,
    });
  };

  const delTaoLichTuDongAPI = (params = {}) => {
    setLoading(true);
    DelTaoLichTuDongcApi({
      id_lichtudong: params.id_lichtudong,
    })
      .then((res) => {
        setLoading(false);
        updateData();
      })
      .catch((err) => {
        openNotificationWithIcon(
          "error",
          "Lỗi",
          "Không thể xóa lịch mặc định. Vui lòng kiểm tra lại"
        );
        // errorHandle(err);
        setLoading(false);
      });
  };

  const onDeleteLichHC_user = (record) => {
    const userId = record.id;
    const dictDate_idLHC = {};
    let countIdHC = 0; //tổng số lượng id trong tất cả các ca làm việc
    for (const key in record) {
      if (key.startsWith("col")) {
        const colT = record[key];
        dictDate_idLHC[colT.dateHC] = colT.ca.map((ca) => ca.id);
        countIdHC += colT.ca.length;
      }
    }
    if (countIdHC == 0) {
      openNotificationWithIcon(
        "warning",
        "Cảnh báo",
        "Không có lịch làm việc để xóa."
      );
      return false;
    }

    DeleteItemLichLamViecApi({
      user: userId,
      dictDate_idLHC: dictDate_idLHC,
      typeDeleteLHC: "Delete_week", // Delete_time: xóa từng khung giờ | Delete_week: xóa cả tuần | Delete_Team: xóa theo team trong tuần
    })
      .then((res) => {
        updateData();
      })
      .catch((err) => {
        errorHandle(err);
      });
  };

  const getButtonChangeStatus = (record) => {
    return (
      <>
        <Space size="middle">
          <span
            title={"Xóa tất cả khung giờ"}
            className={"col-6"}
            style={{ color: "red", cursor: "pointer" }}
          >
            <Popconfirm
              title={`Xóa tất cả khung giờ trong tuần (${record.nhanvien}) ?`}
              onConfirm={() => onDeleteLichHC_user(record)}
              okText="XÓA"
              cancelText="HỦY"
            >
              <MdOutlineAutoDelete
                style={{ color: "#ff4d4f", fontSize: "19px" }}
              />
            </Popconfirm>
          </span>
          {record.id_lichtudong != null && (
            <Col span={12}>
              <span
                title={"Xóa chức năng tạo lịch hàng tuần"}
                className={"col-6"}
                style={{ color: "red", cursor: "pointer" }}
              >
                <Popconfirm
                  placement="topLeft"
                  title={`Xóa chức năng tạo lịch hàng tuần (${record.nhanvien}) ?`}
                  onConfirm={() => {
                    delTaoLichTuDongAPI({
                      id_lichtudong: record.id_lichtudong,
                    });
                  }}
                  okText="Xóa"
                  cancelText="Không"
                >
                  <CarryOutOutlined
                    style={{
                      color: "#ff4d4f",
                      fontSize: "19px",
                      cursor: "pointer",
                    }}
                  // title={"Lịch tự động"}
                  />
                </Popconfirm>
              </span>
            </Col>
          )}
        </Space>
      </>
    );
  };

  const columns = [
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      align: "center",
      width: "5%",
      render: (value, item, index) =>
        ((pager.current || 1) - 1) * pager.pageSize + index + 1,
      sortDirections: ["descend", "ascend", "descend"],
    },
    {
      title: "Nhân viên",
      dataIndex: "nhanvien",
      key: "nhanvien",
      filterKey: "nhanvien",
      type: "text",
      align: "center",
      canSearch: true,
      render: (value, item, index) => value,
      // item.id_lichtudong != null ? (
      //   <>
      //     {value}
      //     <Popconfirm
      //       placement="topLeft"
      //       title={"Xác nhận xóa thiết lập tạo lịch tự động ?"}
      //       onConfirm={() => {
      //         delTaoLichTuDongAPI({ id_lichtudong: item.id_lichtudong });
      //         console.log(item.id_lichtudong);
      //       }}
      //       okText="Xóa"
      //       cancelText="Không"
      //     >
      //       <CarryOutTwoTone
      //         style={{ fontSize: "20px", float: "right", cursor: "pointer" }}
      //         title={"Lịch tự động"}
      //       />
      //     </Popconfirm>
      //   </>
      // ) : (
      //   value
      // ),
      // id_lichtudong
    },
    {
      title:
        currentSelectedDate.month() == moment(lsDate[0]).month()
          ? getHeader(0, lsDate)
          : "Thứ 2",
      dataIndex: "colT2",
      key: "colT2",
      filterKey: "colT2",
      type: "text",
      align: "center",
      canSearch: true,
      render: (text, record) =>
        currentSelectedDate.month() == moment(lsDate[0]).month() ? (
          <RenderItemRow
            text={text}
            updateData={updateData}
            setIsShowAddItem={setIsShowAddItem}
            setCurrentItem={setCurrentItem}
            dateSelected={lsDate[0]}
            setCurrentDateSelected={setCurrentDateSelected}
            setUserId={setUserId}
            setUserName={setUserName}
            setIsShowAddItemNew={setIsShowAddItemNew}
            record={record}
            setIsShowEditItem={setIsShowEditItem}
            teamPermissions={userInfo.team_permissions}
          />
        ) : (
          "-"
        ),
    },
    {
      title:
        currentSelectedDate.month() == moment(lsDate[1]).month()
          ? getHeader(1, lsDate)
          : "Thứ 3",
      dataIndex: "colT3",
      key: "colT3",
      filterKey: "colT3",
      align: "center",
      type: "text",
      canSearch: true,
      render: (text, record) =>
        currentSelectedDate.month() == moment(lsDate[1]).month() ? (
          <RenderItemRow
            text={text}
            updateData={updateData}
            setIsShowAddItem={setIsShowAddItem}
            setCurrentItem={setCurrentItem}
            dateSelected={lsDate[1]}
            setCurrentDateSelected={setCurrentDateSelected}
            setUserId={setUserId}
            setUserName={setUserName}
            setIsShowAddItemNew={setIsShowAddItemNew}
            record={record}
            setIsShowEditItem={setIsShowEditItem}
            teamPermissions={userInfo.team_permissions}
          />
        ) : (
          "-"
        ),
    },
    {
      title:
        currentSelectedDate.month() == moment(lsDate[2]).month()
          ? getHeader(2, lsDate)
          : "Thứ 4",
      dataIndex: "colT4",
      key: "colT4",
      filterKey: "colT4",
      align: "center",
      type: "text",
      canSearch: true,
      render: (text, record) =>
        currentSelectedDate.month() == moment(lsDate[2]).month() ? (
          <RenderItemRow
            text={text}
            updateData={updateData}
            setIsShowAddItem={setIsShowAddItem}
            setCurrentItem={setCurrentItem}
            dateSelected={lsDate[2]}
            setCurrentDateSelected={setCurrentDateSelected}
            setUserId={setUserId}
            setUserName={setUserName}
            setIsShowAddItemNew={setIsShowAddItemNew}
            record={record}
            setIsShowEditItem={setIsShowEditItem}
            teamPermissions={userInfo.team_permissions}
          />
        ) : (
          "-"
        ),
    },
    {
      title:
        currentSelectedDate.month() == moment(lsDate[3]).month()
          ? getHeader(3, lsDate)
          : "Thứ 5",
      dataIndex: "colT5",
      key: "colT5",
      filterKey: "colT5",
      align: "center",
      type: "text",
      canSearch: true,
      render: (text, record) =>
        currentSelectedDate.month() == moment(lsDate[3]).month() ? (
          <RenderItemRow
            text={text}
            updateData={updateData}
            setIsShowAddItem={setIsShowAddItem}
            setCurrentItem={setCurrentItem}
            dateSelected={lsDate[3]}
            setCurrentDateSelected={setCurrentDateSelected}
            setUserId={setUserId}
            setUserName={setUserName}
            setIsShowAddItemNew={setIsShowAddItemNew}
            record={record}
            setIsShowEditItem={setIsShowEditItem}
            teamPermissions={userInfo.team_permissions}
          />
        ) : (
          "-"
        ),
    },
    {
      title:
        currentSelectedDate.month() == moment(lsDate[4]).month()
          ? getHeader(4, lsDate)
          : "Thứ 6",
      dataIndex: "colT6",
      key: "colT6",
      filterKey: "colT6",
      align: "center",
      type: "text",
      canSearch: true,
      render: (text, record) =>
        currentSelectedDate.month() == moment(lsDate[4]).month() ? (
          <RenderItemRow
            text={text}
            updateData={updateData}
            setIsShowAddItem={setIsShowAddItem}
            setCurrentItem={setCurrentItem}
            dateSelected={lsDate[4]}
            setCurrentDateSelected={setCurrentDateSelected}
            setUserId={setUserId}
            setUserName={setUserName}
            setIsShowAddItemNew={setIsShowAddItemNew}
            record={record}
            setIsShowEditItem={setIsShowEditItem}
            teamPermissions={userInfo.team_permissions}
          />
        ) : (
          "-"
        ),
    },
    {
      title:
        currentSelectedDate.month() == moment(lsDate[5]).month()
          ? getHeader(5, lsDate)
          : "Thứ 7",
      dataIndex: "colT7",
      key: "colT7",
      filterKey: "colT7",
      align: "center",
      type: "text",
      canSearch: true,
      render: (text, record) =>
        currentSelectedDate.month() == moment(lsDate[5]).month() ? (
          <RenderItemRow
            text={text}
            updateData={updateData}
            setIsShowAddItem={setIsShowAddItem}
            setCurrentItem={setCurrentItem}
            dateSelected={lsDate[5]}
            setCurrentDateSelected={setCurrentDateSelected}
            setUserId={setUserId}
            setUserName={setUserName}
            setIsShowAddItemNew={setIsShowAddItemNew}
            record={record}
            setIsShowEditItem={setIsShowEditItem}
            teamPermissions={userInfo.team_permissions}
          />
        ) : (
          "-"
        ),
    },
    {
      title:
        currentSelectedDate.month() == moment(lsDate[6]).month()
          ? getHeader(6, lsDate)
          : "Chủ nhật",
      dataIndex: "colCN",
      key: "colCN",
      filterKey: "colCN",
      align: "center",
      type: "text",
      canSearch: true,
      render: (text, record) =>
        currentSelectedDate.month() == moment(lsDate[6]).month() ? (
          <RenderItemRow
            text={text}
            updateData={updateData}
            setIsShowAddItem={setIsShowAddItem}
            setCurrentItem={setCurrentItem}
            dateSelected={lsDate[6]}
            setCurrentDateSelected={setCurrentDateSelected}
            setUserId={setUserId}
            setUserName={setUserName}
            setIsShowAddItemNew={setIsShowAddItemNew}
            record={record}
            setIsShowEditItem={setIsShowEditItem}
            teamPermissions={userInfo.team_permissions}
          />
        ) : (
          "-"
        ),
    },
    {
      title: "Thao tác",
      dataIndex: "",
      className: "highlight",
      key: "",
      filterKey: "",
      type: "text",
      align: "center",
      width: "5%",
      render: (text, record) => getButtonChangeStatus(record),
      canSearch: true,
    },
  ];

  const handleChange = (pagination) => {
    const currentPager = { ...pager };
    currentPager.current = pagination.current;
    currentPager.pageSize = pagination.pageSize;
    setPager({ ...currentPager });
    fetchData({
      idTeam: currentTeam,
      lsDate: lsDate,
      status: currentPager.status,
      page_size: pagination.pageSize,
      page: pagination.current,
      search,
    });
  };

  const onChangeMonth = (date) => {
    setIsCreate(false);
    setCurrentSelectedDate(date);
    const lsDateTemp = getDateRange(date);
    setLsDate(lsDateTemp);
  };

  const getDateRange = (date) => {
    // debugger
    const current = date._d.getDay() === 0 ? 7 : date._d.getDay();
    const firstDay = new Date(
      new Date(date).getTime() - (current - 1) * 24 * 60 * 60 * 1000
    );
    const endDay = new Date(
      new Date(firstDay).getTime() + 6 * 24 * 60 * 60 * 1000
    );
    return getDaysArray(firstDay, endDay);
  };

  const onTaoLichLamViec = () => {
    setIsShowTaoLichLamViec(true);
  };
  const onCancelTaoLichLamViec = () => {
    // fetchData({
    //   idTeam: currentTeam,
    //   lsDate: lsDate,
    //   page: pager.current,
    //   page_size: pager.pageSize,
    // });
    updateData();
    setIsShowTaoLichLamViec(false);
    setIsCreate(false);
  };

  const onSearch = (e) => {
    const search = e.target.value;
    setSearch(search);
  };

  useEffect(() => {
    const arrDay = generateArrWeekAndDays(
      currentSelectedDate.year(),
      currentSelectedDate.month() + 1
    );
    setLsAllWeek(arrDay);
    setCurrentWeek(
      arrDay.filter((item) =>
        item.days.some((date) => date.isSame(currentSelectedDate, "date"))
      )[0].name
    );
  }, [currentSelectedDate]);

  const onQuickChangeWeek = (type) => {
    const arrDay = generateArrWeekAndDays(
      currentSelectedDate.year(),
      currentSelectedDate.month() + 1
    );
    let lenWeek = 7;
    if (type === "previous") {
      arrDay.forEach(function (iWeek, index) {
        if (
          iWeek.days.some((date) => date.isSame(currentSelectedDate, "date"))
        ) {
          if (index == 0) {
            arrDay[index].days.length == 7 ? (lenWeek = -7) : (lenWeek = 0);
          } else {
            lenWeek = -arrDay[index - 1].days.length;
          }
        }
      });
    } else {
      arrDay.forEach(function (iWeek, index) {
        if (
          iWeek.days.some((date) => date.isSame(currentSelectedDate, "date"))
        ) {
          index == arrDay.length - 1
            ? (lenWeek = arrDay[arrDay.length - 1].days.length)
            : (lenWeek = 7);
        }
      });
    }
    const numberDay = lenWeek;
    // const numberDay = type === 'previous' ? -lenWeek : lenWeek;
    // const lsDateInMonth = lsDate.filter(item => moment(currentSelectedDate).month() == moment(item).month());
    const newFirstDate = new Date(
      new Date(lsDate[0]).getTime() + numberDay * 24 * 60 * 60 * 1000
    );
    const lsDateTemp = getDateRange(moment(newFirstDate));
    setCurrentSelectedDate(moment(newFirstDate));
    setLsDate(lsDateTemp);

    const arrDayNew = generateArrWeekAndDays(
      moment(newFirstDate).year(),
      moment(newFirstDate).month() + 1
    );
    setLsAllWeek(arrDayNew);
    setCurrentWeek(
      arrDayNew.filter((item) =>
        item.days.some((date) => date.isSame(moment(newFirstDate), "date"))
      )[0].name
    );
  };

  const onChangeSelectWeek = (value) => {
    setCurrentWeek(value);
    const lsAllWeekChange = lsAllWeek.filter((item) => item.name == value);
    setCurrentSelectedDate(lsAllWeekChange[0].days[0]);
    const lsDateTemp = getDateRange(lsAllWeekChange[0].days[0]);
    setLsDate(lsDateTemp);
  };

  const onChangeBoPhan = (value) => {
    if (value.length > 0) {
      setCurrentBoPhan(value);
      const lsTeamWith_BP = lsAllTeam.filter((x) => value.includes(x.idBoPhan));
      setLsTeam(lsTeamWith_BP);
      setCurrentTeam([lsTeamWith_BP.map((item) => item.idTeam)[0]]); // 200423
      // setCurrentTeam(lsTeamWith_BP.map((item) => item.idTeam)); //27/11/2022
    } else {
      setLsTeam([]);
      setCurrentBoPhan([]);
      setCurrentTeam([]);
    }
  };

  const tPropsConfig_BoPhan = {
    treeData: [
      {
        title:
          currentBoPhan.length > 0 ? (
            <span
              onClick={() => {
                if (!loading) {
                  onChangeBoPhan([]);
                }
              }}
              className="style_SelectTeam"
            >
              Bỏ chọn tất cả
            </span>
          ) : (
            <span
              onClick={() => {
                if (!loading) {
                  onChangeBoPhan(lsBoPhan.map((item) => item.id));
                }
              }}
              className="style_SelectTeam"
            >
              Chọn tất cả
            </span>
          ),
        value: "xxx",
        disableCheckbox: true,
        disabled: true,
        className: "style_treeTeam",
      },
      ...treeDataBoPhan,
    ],
    value: treeDataBoPhan.length > 0 ? currentBoPhan : undefined,
    onChange: onChangeBoPhan,
    treeCheckable: true,
    // showCheckedStrategy: SHOW_PARENT,
    maxTagCount: 2,
    placeholder: "Chọn bộ phận",
    style: { width: "fit-content", minWidth: 200 },
    disabled: loading,
  };

  useEffect(() => {
    const treeDataBoPhan = lsBoPhan.map((item) => {
      return { title: item.tenBophan, value: item.id, key: item.id };
    });
    setTreeDataBoPhan(treeDataBoPhan);
    if (currentBoPhan.length === 0) {
      setCurrentBoPhan(lsBoPhan.map((item) => item.id));
    }
  }, [lsBoPhan]);

  const onBlurTeamSelect = () => {
    if (currentTeam.length === 0) {
      openNotificationWithIcon("error", "Lỗi", "Vui lòng chọn ít nhất 1 team");
    }
  };

  const onChangeTeam = (value) => {
    if (loading) {
      return;
    }
    if (value.length > 0) {
      setCurrentTeam(value);
    } else {
      setCurrentTeam([]);
    }
  };

  const tPropsConfig = {
    treeData: [
      {
        title:
          currentTeam.length > 0 ? (
            <span
              onClick={() => {
                setCurrentTeam([]);
                onChangeTeam([]);
              }}
              style={{
                display: "inline-block",
                color: "#286FBE",
                cursor: "pointer",
              }}
            >
              Bỏ chọn tất cả
            </span>
          ) : (
            <span
              onClick={() => {
                setCurrentTeam(lsTeam.map((item) => item.idTeam));
                onChangeTeam(lsTeam.map((item) => item.idTeam));
              }}
              style={{
                display: "inline-block",
                color: "#286FBE",
                cursor: "pointer",
              }}
            >
              Chọn tất cả
            </span>
          ),
        value: "xxx",
        disableCheckbox: true,
        disabled: true,
      },
      ...treeData,
    ],
    value: treeData.length > 0 ? currentTeam : undefined,
    onChange: onChangeTeam,
    onBlur: onBlurTeamSelect,
    treeCheckable: true,
    // showCheckedStrategy: SHOW_PARENT,
    maxTagCount: 2,
    allowClear: false,
    placeholder: "Chọn team",
    style: { width: "fit-content", minWidth: 200 },
    disabled: loading,
  };
  useEffect(() => {
    const treeDataTemp = lsTeam.map((item) => {
      return { title: item.team, value: item.idTeam, key: item.idTeam };
    });
    setTreeData(treeDataTemp);
    // if (currentTeam.length === 0){
    //     setCurrentTeam(lsTeam.map(item=>item.idTeam));
    // };
    // setCurrentTeam(lsTeam.map(item=>item.idTeam));
  }, [lsTeam]);

  const onModalDeleteLichHC = () => {
    setIsDeleteLichHC(true);
  };
  const onCancelDeleteLichHC = () => {
    setIsDeleteLichHC(false);
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0 font-size-18">
              Lịch làm việc (
              {moment(
                lsDate.filter(
                  (item) =>
                    moment(currentSelectedDate).month() == moment(item).month()
                )[0]
              ).format("DD/MM/YYYY") +
                "-" +
                moment(
                  lsDate
                    .filter(
                      (item) =>
                        moment(currentSelectedDate).month() ==
                        moment(item).month()
                    )
                    .at(-1)
                ).format("DD/MM/YYYY")}
              )
            </h4>
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link href="#">Quản lý</Link>
                </li>
                <li className="breadcrumb-item">Lịch làm việc</li>
                <li className="breadcrumb-item active">
                  <a>Lịch hành chính</a>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className={"col-24 mb-2 d-sm-flex align-items-center"}>
          <div className={"col-24 mb-2 d-sm-flex align-items-center"}>
            <div className={"col"}>
              <Space align="center" className="space-align-block styleNtn_1">
                <Button
                  type={"primary"}
                  className={"styleNtn_1 addBtnWeek"}
                  onClick={() => onQuickChangeWeek("previous")}
                  title="Tuần trước"
                >
                  <i className={"fa fa-arrow-left"}></i>
                </Button>
                <Select onChange={onChangeSelectWeek} value={currentWeek}>
                  {lsAllWeek.map((item, key) => (
                    <Select.Option key={item.name} value={item.name}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>

                <Button
                  type={"primary"}
                  className={"styleNtn_1 addBtnWeek"}
                  onClick={() => onQuickChangeWeek("next")}
                  title="Tuần sau"
                >
                  <i className={"fa fa-arrow-right"}></i>
                </Button>
              </Space>

              <DatePicker
                style={{ borderRadius: 10 }}
                className={"m-2"}
                onChange={onChangeMonth}
                value={currentSelectedDate}
                format={"DD/MM/YYYY"}
                allowClear={false}
              />
              <div className="styleBadge">
                <Badge.Ribbon
                  text="Bộ phận"
                  color="gray"
                  style={{ color: "red" }}
                >
                  <TreeSelect {...tPropsConfig_BoPhan} />
                </Badge.Ribbon>
              </div>
              <div className="styleBadge">
                <Badge.Ribbon text="Team" color="gray" style={{ color: "red" }}>
                  <TreeSelect {...tPropsConfig} />
                </Badge.Ribbon>
              </div>
            </div>
          </div>

          <div className={"col"}>
            <Row gutter={[8, 8]} style={{ flexDirection: "row-reverse" }}>
              <Col>
                {isCreate === false && currentTeam.length > 0 && (
                  <Button
                    type={"primary"}
                    danger
                    onClick={() => onModalDeleteLichHC()}
                    icon={<MinusCircleOutlined />}
                    title="Xóa lịch trong tuần của team"
                  >
                    Xóa lịch làm việc
                  </Button>
                )}
              </Col>
              <Col>
                {isCreate === false && currentTeam.length > 0 && (
                  <Button
                    type={"primary"}
                    onClick={() => onTaoLichLamViec()}
                    icon={<PlusCircleOutlined />}
                  >
                    Tạo lịch làm việc
                  </Button>
                )}
              </Col>
              <Col>
                <Search
                  placeholder="Tìm mã NV, username"
                  size="middle"
                  onChange={onSearch}
                  loading={false}
                  className={"styleSearch"}
                  suffix={<SearchOutlined className="site-form-item-icon" />}
                  enterButton
                />
              </Col>
              {isShowTaoLichLamViec && (
                <ModalTaoLichLamViec
                  visible={isShowTaoLichLamViec}
                  onCancel={() => onCancelTaoLichLamViec()}
                  caLamViec={lsCaLamViec}
                  lsDate={lsDate}
                  data={data}
                  lsMemberId={lsMemberId}
                  currentTeam={currentTeam}
                  lsTeam={lsTeam}
                  currentSelectedDate={currentSelectedDate}
                  userInfo={userInfo}
                />
              )}
              {isShowDeleteLichHC && (
                <ModalDeleteLichHC
                  visible={isShowDeleteLichHC}
                  onCancel={() => onCancelDeleteLichHC()}
                  updateData={updateData}
                  lsDate={lsDate}
                  data={data}
                  currentTeam={currentTeam}
                  lsTeam={lsTeam}
                  currentSelectedDate={currentSelectedDate}
                />
              )}
            </Row>
          </div>
        </div>
      </div>
      <div className="row">
        <Table
          dataSource={data}
          columns={columns}
          loading={loading}
          bordered={true}
          className={"custom-table-hover style-6"}

          scroll={
            data.length > 0 && { x: 1200, y: "55svh" }
          }
          // scroll={{ x: 1200 }}
          size={"small"}
          rowKey="id"
          onChange={handleChange}
          locale={{
            emptyText: (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={
                  <span>
                    <h3 className={"text text-danger text-center"}>
                      {currentTeam.length === 0
                        ? "Vui lòng chọn ít nhất 1 team"
                        : search
                          ? "Không có kết quả phù hợp"
                          : "Chưa xếp lịch làm việc tuần này"}
                    </h3>
                  </span>
                }
              />
            ),
          }}
          pagination={{
            current: pager.current,
            pageSize: pager.pageSize,
            total: totalPage,
            showSizeChanger: true,
            pageSizeOptions: ["50", "75", "100"],
          }}
        />
      </div>

      <ModalAddSingleItemLichLamViec
        visible={isShowAddItem}
        onCancel={() => setIsShowAddItem(false)}
        item={currentItem}
        currentDate={currentDateSelected}
        lsCa={lsCaLamViec}
        userId={userId}
        userName={userName}
        updateData={updateData}
        lsDate={lsDate}
      />
      <ModalEditSingleItemLichLamViec
        visible={isShowEditItem}
        onCancel={() => setIsShowEditItem(false)}
        item={currentItem}
        currentDate={currentDateSelected}
        lsCa={lsCaLamViec}
        userId={userId}
        userName={userName}
        updateData={updateData}
      />
    </>
  );
};
